import { pxToRem } from '../../utils';
export default (function () { return ({
    margin: pxToRem(8),
    gutterMargin: pxToRem(10),
    messageMargin: pxToRem(40),
}); });
